import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { useMap } from "react-leaflet";
import { db } from "../firebase";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";

const emergencyIcon = new L.Icon({
  iconUrl: "/emergency-marker.png",
  iconSize: [40, 40],
  iconAnchor: [20, 40],
});

const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

const openInMaps = (lat, lng) => {
  if (isIOS()) {
    // Apple Maps
    window.location.href =
      `https://maps.apple.com/?ll=${lat},${lng}&q=Emergency%20Location`;

  } else {
    // Google Maps
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
      "_blank"
    );
  }
};


const RecenterMap = ({ lat, lng }) => {
  const map = useMap();

  useEffect(() => {
    if (lat && lng) {
      map.setView([lat, lng], map.getZoom(), {
        animate: true,
      });
    }
  }, [lat, lng, map]);

  return null;
};
const LocationView = () => {
  const [params] = useSearchParams();
  const trackId = params.get("trackId");
  const [location, setLocation] = useState(null);

  useEffect(() => {
  if (!trackId) return;

  const unsub = onSnapshot(
    doc(db, "sms_locations", trackId),
    (snap) => {
      if (snap.exists()) {
        const data = snap.data();

        setLocation({
          ...data,
          lat: Number(data.lat),
          lng: Number(data.lng),
        });
      }
    }
  );

  return () => unsub();
}, [trackId]);


 if (!location) {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h2>Waiting for live location…</h2>
    </div>
  );
}

return (
  <div style={{ height: "100vh", width: "100vw", position: "relative" }}>
    {/* 🔍 DEBUG OVERLAY */}
    <div
      style={{
        position: "absolute",
        top: 10,
        left: 10,
        zIndex: 1000,
        background: "rgba(0,0,0,0.7)",
        color: "#fff",
        padding: "10px 14px",
        borderRadius: "8px",
        fontSize: "14px",
      }}
    >
      <div><b>Track ID:</b> {trackId}</div>
      <div><b>Lat:</b> {location.lat}</div>
      <div><b>Lng:</b> {location.lng}</div>
    </div>

    {/* 🗺 MAP */}
    <MapContainer
      center={[location.lat, location.lng]}
      zoom={16}
      style={{ height: "100%", width: "100%" }}
    >
     <TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution="© OpenStreetMap contributors"
/>

 <RecenterMap lat={location.lat} lng={location.lng} />

<Marker
  position={[location.lat, location.lng]}
  icon={emergencyIcon}
  eventHandlers={{
    click: () => openInMaps(location.lat, location.lng),
  }}
/>
    </MapContainer>
  </div>
);

};

export default LocationView;
